/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Types
import { FailedCall } from '../../../shared/types/manageCalls';

// Environment
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WebServiceCaller {
  private readonly WEBSERVICES_MODE = environment.WEBSERVICES_MODE as 'ONLINE' | 'LOCAL';
  private readonly WEB_SERVICE_URL = environment.WEBSERVICES[this.WEBSERVICES_MODE].WEB_SERVICE_URL;

  private readonly http = inject(HttpClient);

  getCall<T = unknown>(resource: string): Observable<T> {
    return this.http.get<T>(this.buildUrl(resource)).pipe(catchError(this.errorHandle));
  }

  postCall<T = unknown>(resource: string, body: unknown = {}): Observable<T> {
    return this.http.post<T>(this.buildUrl(resource), body).pipe(catchError(this.errorHandle));
  }

  postCallBuffer(resource: string, body: unknown = {}): Observable<HttpEvent<ArrayBuffer>> {
    return this.http
      .post(this.buildUrl(resource), body, { responseType: 'arraybuffer', reportProgress: true, observe: 'events' })
      .pipe(catchError(this.errorHandle));
  }

  putCall<T = unknown | FailedCall>(resource: string, body: unknown = {}): Observable<T> {
    return this.http.put<T>(this.buildUrl(resource), body).pipe(catchError(this.errorHandle));
  }

  // Error handling
  private errorHandle({ error }: { error: FailedCall }): Observable<never> {
    return throwError(() => error);
  }

  private buildUrl(resource: string): string {
    return [this.WEB_SERVICE_URL, '/', resource].join('');
  }
}
